// Столбики волны выглядят случайными, но зависят ТОЛЬКО от длительности:
// две записи одной длины рисуются одинаково (требование us/10772).
// Генератор 32-битный (Math.imul), чтобы результат не зависел от округления
// больших чисел и был одинаковым в любом движке.
const WAVE_SEED_OFFSET = 7;
const LCG_MULTIPLIER = 1103515245;
const LCG_INCREMENT = 12345;
const UINT32 = 4294967296;
const MIN_BAR_HEIGHT = 0.2;
const BASE_BAR_HEIGHT = 0.15;
const ENVELOPE_BASE = 0.55;
const ENVELOPE_AMPLITUDE = 0.45;

export const buildLeadAudioWave = (
  durationSec: number,
  bars: number
): number[] => {
  if (bars <= 0) return [];

  let seed = (Math.round(durationSec * 1000) + WAVE_SEED_OFFSET) >>> 0;

  return Array.from({ length: bars }, (_, index) => {
    seed = (Math.imul(seed, LCG_MULTIPLIER) + LCG_INCREMENT) >>> 0;

    const random = seed / UINT32;
    // Огибающая делает волну выше к середине — иначе столбики выглядят
    // однородным шумом, а не записью голоса.
    const envelope =
      bars === 1
        ? 1
        : ENVELOPE_BASE +
          ENVELOPE_AMPLITUDE * Math.sin((index / (bars - 1)) * Math.PI);

    return Math.max(
      MIN_BAR_HEIGHT,
      Math.min(1, random * envelope + BASE_BAR_HEIGHT)
    );
  });
};

export const formatLeadAudioTime = (seconds: number): string => {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';

  const total = Math.floor(seconds);
  const minutes = Math.floor(total / 60);
  const rest = total % 60;

  return `${minutes}:${rest.toString().padStart(2, '0')}`;
};

// Бэк отдаёт Duration строкой и не для всех файлов: встречаются и секунды
// числом, и «мм:сс». Не распарсили — длительность узнаем из самого файла
// после загрузки.
export const parseLeadAudioDuration = (raw: string | null): number => {
  if (!raw) return 0;

  const value = raw.trim();
  if (!value) return 0;

  if (value.includes(':')) {
    const parts = value.split(':').map((part) => Number(part));
    if (parts.some((part) => !Number.isFinite(part))) return 0;

    return parts.reduce((total, part) => total * 60 + part, 0);
  }

  const seconds = Number(value);

  return Number.isFinite(seconds) && seconds > 0 ? seconds : 0;
};
